import axios from "axios"
import RestService from "./rest.service";

const API_URL = process.env.REACT_APP_API_URL;

class myGoalService {
  getGoalList(id, page) {
    return new Promise((fnResolve, fnReject) => {
      if (id == null) id = 1;
      if (page !== null && page !== undefined) page = `?page=${page}`
      else page = ''
      RestService.getMyGoal(`app/kpi/goal/mygoal/${id}` + page).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getGoalListByEvaluate(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getMyGoal(`app/kpi/goal/mygoal/get/${id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getGoalCycle(id) {
    return new Promise((fnResolve, fnReject) => {
      let form_evaluate = id ? `&form_evaluate=${id}` : ''
      RestService.getMyGoal("app/kpi/kpi_form?type=goal" + form_evaluate).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getGoalCorporateLogDelete(workloadForm) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets("app/admin/kpi/corporate-goal/log?cycle_id=" + workloadForm).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getGoalCorporateLogByGoalID(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/corporate-goal/${id}/log`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getGroup(search, id) {
    return new Promise((fnResolve, fnReject) => {
      var api = "app/kpi/goals/library/mygoalGroup";
      var searchConvert = search;
      if (searchConvert) {
        searchConvert = searchConvert.replace(/ /g, '%20');
        searchConvert = searchConvert.replace(/#/g, '%23')
      }
      if (id) {
        api += `?id=${id}`
      }
      if (search) {
        api += `&search=${searchConvert}`
      }
      RestService.getMyGoal(api).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getDropdownMetric() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getMyGoal("app/kpi/goals/dropdown/mygoalMetric").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getDropdownUnit() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getMyGoal("app/kpi/goals/dropdown/mygoalMetricValue").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getType(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getMyGoal(`app/kpi/goals/dropdown/mygoalType?serial=${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getCategory(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getMyGoal(`app/kpi/goals/dropdown/mygoalCategory?serial=${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getScaleLevel(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getMyGoal(`app/kpi/goals/dropdown/scaleLevelList?serial=${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getCustomForm(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getMyGoal(`app/kpi/goals/dropdown/customForm?serial=${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getCategoryWeight(id, serial, goalSerial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getMyGoal(`app/kpi/goals/dropdown/mygoalCategoryWeight?categorySerial=${id}&evaluatorSerial=${serial}&formGoalSerial=${goalSerial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getLibraryList(id, perPage, currentPage, search, groupIn) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/library/mygoalLibraryList?perPage=${perPage}&currentPage=${currentPage}&id=${id}`;
      if (search) {
        api += `&search=${search}`
      }
      if (groupIn) {
        var joinGroup = groupIn.join(',');
        api += `&groupIn=${joinGroup}`
      }
      RestService.getMyGoal(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getMemberTeamList() {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/dropdown/mygoalMemberTeamList`;
      RestService.getMyGoal(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getMemberList(serial) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/dropdown/mygoalMemberList?serial=${serial}`;
      RestService.getMyGoal(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getEvaluatorList() {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/dropdown/mygoalEvaluatorList`;
      RestService.getMyGoal(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getAlignmentList(cycle_id = null) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/dropdown/mygoalAlignment`;
      if (cycle_id) api += '?cycle=' + cycle_id

      RestService.getMyGoal(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getMyGoalDetail(serial, opt = {}) {
    return new Promise((fnResolve, fnReject) => {
      console.log('getMyGoalDetail', opt)
      var api = `app/kpi/goals/${serial}`;

      if (Object.keys(opt).length > 0) {
        let options = []
        for (const key in opt) options.push(key + '=' + opt[key])

        if (options.length > 0) api += '?' + options.join('&')
      }
      console.log('api', api)

      RestService.getMyGoal(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getMyGoalProgress(serial) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/${serial}/progress`;
      RestService.getMyGoal(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  postCreateMygoal(data) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goal/create`;
      RestService.addMyGoal(`${api}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  putEditMyGoal(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goal/${serial}`;
      RestService.editMyGoal(`${api}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getMyGoalEditDetail(serial) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/detail/mygoalEdit?serial=${serial}`;
      RestService.getMyGoal(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  deleteMyGoal(serial) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goal/${serial}`;
      RestService.deleteMyGoal(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  putDeleteMyGoal(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goal/delete/${serial}`;
      RestService.putDeleteMyGoal(`${api}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getGoalForEdit(serial) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goal/${serial}`;
      RestService.getGoalForEdit(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  postSubmitApproval(data) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/workflow/goal/request`;
      RestService.postSubmitApproval(`${api}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  putUpdateProgress(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/${serial}/progress`;
      RestService.putUpdateProgress(`${api}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  putUpdateProgressHistory(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/${serial}/historyProgress`;
      RestService.putUpdateProgress(`${api}`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  deleteProgressHistory(serial) {
    return new Promise((fnResolve, fnReject) => {
      var api = `app/kpi/goals/${serial}/historyProgress`;
      RestService.deleteProgressHistory(`${api}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}


export default new myGoalService();
